import React from 'react';
import { NumberInput } from 'react-admin';
import { Box } from '@mui/material';
import { getInheritedValue } from 'utils/rateSettings/SharedRateSettingsForm.utils';
import { useRateControllerContext } from '../rateController/RateControllerContext';
import { RateFieldCheckbox } from './RateFieldCheckbox';

type Props = {
  source: string;
  field: string;
  label: string;
  inheritedSettings: any;
  controllable?: boolean;
};

export const BaseMarginPercentInput = ({
  source,
  field,
  label,
  inheritedSettings,
  controllable = false,
}: Props) => {
  const { isControlled } = useRateControllerContext();
  const helperText = String(getInheritedValue(inheritedSettings, field, undefined) || '');

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <NumberInput
        source={`${source}.${field}`}
        label={label}
        helperText={helperText}
        disabled={controllable && !isControlled('baseMargin')}
        sx={controllable ? { flex: 1 } : undefined}
      />
      {controllable && <RateFieldCheckbox code="baseMargin" label="Admin controls Base Margin" />}
    </Box>
  );
};
